import type { TeamIntegration } from '@rhythmic/db/types'
import { DeleteTeamIntegrationSchema } from '@rhythmic/types'
import type { Transaction } from '@tanstack/vue-db'
import { useRhythmicLogger } from '#imports'
import { getTeamIntegrationsCollection } from '../../contexts/getCollections'

const logger = useRhythmicLogger('useTeamIntegrationsContext:deleteTeamIntegration')

export interface DeleteTeamIntegrationContext {
  teamId: string
}

export default function handleDeleteTeamIntegration(
  integrationId: string,
  context: DeleteTeamIntegrationContext,
): Transaction<TeamIntegration> | undefined {
  try {
    const { teamId } = context

    if (!teamId) {
      const error = new Error('Team context is not ready')
      logger.error('Unable to delete team integration: missing team identifier')
      throw error
    }

    const parsed = DeleteTeamIntegrationSchema.parse({ id: integrationId })
    const collection = getTeamIntegrationsCollection(teamId)

    const transaction = collection.delete(parsed.id)

    logger.info('Team integration deleted via collection', {
      teamId,
      integrationId: parsed.id,
    })

    return transaction as Transaction<TeamIntegration> | undefined
  } catch (error) {
    logger.error('deleteTeamIntegration failed', { integrationId, error })
    if (error instanceof Error) throw error
    throw new Error('Failed to delete team integration')
  }
}
